import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PagoAutomaticoIcon from '@mui/icons-material/PointOfSale';
import PagoManualIcon from '@mui/icons-material/MailOutline';
import { DateTime } from 'luxon';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Collapse,
  Box,
  Typography,
  Divider,
  IconButton,
  Chip
} from '@mui/material';
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Receipt as ReceiptIcon,
  AttachMoney as AttachMoneyIcon
} from '@mui/icons-material';


const session = require('../../config/session')

class DepositosTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      depositos: [],
      filaExpandida: null,
      detallesActivos: []
    };
  }

  handleExpand = (index) => {
    const yaExpandida = this.state.filaExpandida === index;
    if (yaExpandida) {
      this.setState({ filaExpandida: null });
    } else {
      this.setState({ filaExpandida: index });
    }
  }

  calcularArqueo = (detalle) => {

    // denom -> { cantidad, vieja, nueva }. familia 'A' = vieja, 'B' = nueva
    // (solo la trae el CA10; los demas billetes quedan sin familia -> solo cuentan al total).
    const arqueoMap = new Map();

      const contenido = typeof detalle === 'string' ? JSON.parse(detalle) : detalle || {};
      const secciones = Object.values(contenido);

    secciones.forEach((seccion) => {
        if (seccion?.currencies) {
          seccion.currencies.forEach((currency) => {
            currency.bills.forEach((bill) => {
              const denom = bill.denomination;
              const cantidad = bill.amount;
              const fam = String(bill.familia || '');
              const cur = arqueoMap.get(denom) || { cantidad: 0, vieja: 0, nueva: 0 };
              cur.cantidad += cantidad;
              if (fam === 'A') cur.vieja += cantidad;
              else if (fam === 'B') cur.nueva += cantidad;
              arqueoMap.set(denom, cur);
            });
          });
        }
    });


    const arqueoFinal = Array.from(arqueoMap.entries())
      .sort((a, b) => b[0] - a[0]) // Orden descendente por denominación
      .map(([denominacion, v]) => ({
        denominacion,
        cantidad: v.cantidad,
        vieja: v.vieja,
        nueva: v.nueva,
        subtotal: denominacion * v.cantidad
      }));

    return arqueoFinal;
  };



render(){
  const { filaExpandida,  } = this.state;
  const depositos = this.props.depositos;

  const columns = [
    {field: "desplegable", headerName: "", width: 10},
    {field: "fecha_hora", headerName: 'Fecha Deposito', width: 200},
    {field: "codigo_cajero", headerName: 'Codigo Cajero', width: 150},
    {field: "tipo_transaccion", headerName: 'Tipo', width: 50},
    {field: "Transaccion", headerName: 'Transaccion', width: 50},
    {field: "alias_cajero", headerName: 'Alias Cajero', width: 170},
    {field: "entidad", headerName: 'Entidad', width: 100},
    {field: "nombre_cliente", headerName: 'Depositante', width: 200},
    {field: "referencia_pago", headerName: 'ID Depositante', width: 100},
    {field: "valor", headerName: 'Valor', width: 100},
    {field: "moneda", headerName: 'Moneda', width: 30},
    {field: "finalizacion", headerName: 'Finalizacion', width: 100},
    {field: "aprobacion", headerName: 'Aprobacion', width: 100},
    {field: "rechazados", headerName: 'Rechazados', width: 80},

  ]


  return (
    <Paper elevation={3} sx={{ 
      width: '100%', 
      overflow: 'hidden', 
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'divider',
      mb: 3
    }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{
                  '& th': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 'fontWeightBold',
                    fontSize: '0.8rem',
                    py: 1.5,
                    px: 2
                  }
                }}>
                  {columns.map((column) => (
                    <TableCell
                      key={column.field}
                      sx={{
                        width: column.width,
                        textAlign: column.align || 'left',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {column.headerName}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
    
              <TableBody>
                {depositos.map((deposito, index) => {
                  const estaAbierta = filaExpandida === index;
                  return (
                    <React.Fragment key={index}>
                      <TableRow sx={{
                        '&:hover': { backgroundColor: 'action.hover' },
                        '& td': { py: 1.5, px: 2, borderBottom: estaAbierta ? 'none' : undefined }
                      }}>
                        <TableCell>
                          <IconButton 
                            size="small" 
                            onClick={() => this.handleExpand(index)}
                            color={estaAbierta ? 'primary' : 'default'}
                          >
                            {estaAbierta ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </TableCell>
                        <TableCell>{deposito.fecha_registro}</TableCell>

                        <TableCell>
                          {session.checkPermiso('acceder_cajeros_resumen') ? (
                            <Link to={{ pathname: '/dashboard/cajeros/resumen', state: { id_cajero: deposito.id_cajero } }}>
                              {deposito.codigo_cajero}
                            </Link>
                          ) : (
                            <span>{deposito.codigo_cajero}</span>
                          )}
                        </TableCell>
                        <TableCell>{deposito.tipo_transaccion === 100 ? <PagoAutomaticoIcon /> : <PagoManualIcon />}</TableCell>
                        <TableCell>{deposito.TipoTransaccion}</TableCell>
                        <TableCell>{deposito.alias_cajero}</TableCell>
                        <TableCell>{deposito.entidad}</TableCell>
                        <TableCell>{deposito.nombre_cliente}</TableCell>
                        <TableCell>{deposito.referencia_pago}</TableCell>

                        <TableCell sx={{ fontWeight: 'fontWeightMedium', textAlign: 'right', color: 'success.main' }}>
                          ${deposito.valor.toLocaleString()}
                        </TableCell>

                        <TableCell>{deposito.moneda}</TableCell>
                        <TableCell>{deposito.finalizacion}</TableCell>
                        <TableCell>{deposito.aprobacion}</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>{deposito.rechazados ?? '-'}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell colSpan={9} sx={{ 
                            p: 0,
                            borderBottom: `1px solid`,
                            borderColor: 'divider'
                          }}>
                          <Collapse in={estaAbierta} timeout="auto" unmountOnExit>
                            {estaAbierta && (() => {
                              const arqueo = this.calcularArqueo(deposito.detalle); // <- CORREGIDO
                              const totalArqueo = arqueo.reduce((acc, item) => acc + item.subtotal, 0);
                              const totalVieja = arqueo.reduce((acc, item) => acc + (item.vieja || 0), 0);
                              const totalNueva = arqueo.reduce((acc, item) => acc + (item.nueva || 0), 0);
                              const esAutomatico = deposito.tipo_transaccion === 100;

                              return (
                                <Box sx={{ 
                                  backgroundColor: 'background.default',
                                  borderLeft: 4,
                                  borderColor: 'primary.main',
                                  p: 3,
                                  widht: '100%'
                                }}> 
                                <Box display="flex" alignItems="center" mb={2}>
                                  <AttachMoneyIcon color="primary" sx={{ mr: 1 }} />
                                  <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                    Fecha de recaudo
                                  </Typography>
                                  <Box component="span" sx={{ ml: 2 }}>
                                    {deposito.fecha_recaudo && deposito.fecha_recaudo.trim() !== "" 
                                      ? deposito.fecha_recaudo 
                                      : "En boveda"}
                                  </Box>
                                </Box>                                                                  
                                  {esAutomatico ? (
                                  <>
                                  <Box display="flex" alignItems="center" mb={2}>
                                    <AttachMoneyIcon color="primary" sx={{ mr: 1 }} />
                                    <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                      Desglose de Efectivo
                                    </Typography>
                                  </Box>
                                  <Divider sx={{ mb: 2 }} />

                                  <Table size="small" sx={{
                                    '& th': { backgroundColor: 'action.selected', fontWeight: 'fontWeightBold' },
                                    '& td, & th': { py: 1, px: 2 }
                                  }}>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Denominacion</TableCell>
                                        <TableCell sx={{ textAlign: 'right' }}>Cantidad</TableCell>
                                        <TableCell sx={{ textAlign: 'right' }}>F. Vieja</TableCell>
                                        <TableCell sx={{ textAlign: 'right' }}>F. Nueva</TableCell>
                                        <TableCell sx={{ textAlign: 'right' }}>Subtotal</TableCell>
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {arqueo.map((row, idx) => (
                                        <TableRow key={idx} hover>
                                          <TableCell>{row.denominacion.toLocaleString()}</TableCell>
                                          <TableCell sx={{ textAlign: 'right' }}>{row.cantidad}</TableCell>
                                          <TableCell sx={{ textAlign: 'right' }}>{row.vieja || 0}</TableCell>
                                          <TableCell sx={{ textAlign: 'right' }}>{row.nueva || 0}</TableCell>
                                          <TableCell sx={{ textAlign: 'right', fontWeight: 'fontWeightMedium' }}>
                                            ${row.subtotal.toLocaleString()}
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>

                                    <TableFooter>
                                      <TableRow sx={{ '& td': { fontWeight: 'fontWeightBold', backgroundColor: 'action.selected' } }}>
                                        <TableCell>Total</TableCell>
                                        <TableCell />
                                        <TableCell sx={{ textAlign: 'right' }}>{totalVieja}</TableCell>
                                        <TableCell sx={{ textAlign: 'right' }}>{totalNueva}</TableCell>
                                        <TableCell sx={{ textAlign: 'right' }}>${totalArqueo.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableFooter>
                                  </Table>
                                  </>
                                  ) : (
                                    <Typography variant="body2" color="text.secondary">
                                      Depósito por sobre — sin desglose de denominaciones.
                                    </Typography>
                                  )}
                                </Box>
                              );
                            })()}
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>

            </Table>
          </TableContainer>
        </Paper>
      );
  }
}


export default DepositosTable;
